export default function scrollToErroredControls(formElement) {
  const fixedNavbar = document.querySelector('.navbar-fixed-top');
  let erroredControls = formElement.querySelectorAll('.has-error .form-control');
  if (erroredControls.length > 0) {
    scrollToElement(erroredControls[0], fixedNavbar);
    return;
  }
  erroredControls = formElement.querySelectorAll('.has-error input');
  if (erroredControls.length > 0) {
    scrollToElement(erroredControls[0], fixedNavbar);
    return;
  }
  erroredControls = formElement.querySelectorAll('.has-error select');
  if (erroredControls.length > 0) {
    scrollToElement(erroredControls[0], fixedNavbar);
    return;
  }
  erroredControls = formElement.querySelectorAll('.has-error textarea');
  if (erroredControls.length > 0) {
    scrollToElement(erroredControls[0], fixedNavbar);
    return;
  }
  erroredControls = formElement.querySelectorAll('.has-error .form-control-static');
  if (erroredControls.length > 0) {
    scrollToElement(erroredControls[0], fixedNavbar);
    return;
  }
}

function scrollToElement(element, fixedNavbar = null) {
  if (element.scrollIntoView) {
    element.scrollIntoView(true);
    if (fixedNavbar) {
      const scrolledY = window.scrollY;
      if (scrolledY) {
        window.scroll(0, scrolledY - fixedNavbar.scrollHeight - 30);
      }
    }
  }
  element.focus();
  return;
}
